// data/artistes2025.js
export const artistes2025 = [
  {
    id: 2,
    name: "Spoink",
    image: "/assets/artistes/2025/Spoink_Slide_1.webp",
    image2: "/assets/artistes/2025/Spoink_Slide_2.webp",
    description:
      "Rien n'est prévu. Tout est joué.\nQuatre musiciens, branchés serré.\nDes machines, des instruments, de la sueur.\nÇa commence sans savoir où ça va.\nÇa groove, ça déraille, ça retombe sur ses pattes.\nDrum & bass ? Parfois. Dubstep ? Possible.\nClub étrange ? Souvent.\nPas de setlist. Pas de filet.\nLe son se fabrique en direct, avec les mains, les oreilles,\nles corps.\nSpoink, c'est ça : une improvisation qui donne envie de bouger.",
    genre: "Electro Impro",
    time: "",
    socialLinks: {
      instagram: "https://instagram.com/spoinkmusic",
      site: "https://spoinkmusic.fr/",
    },
    video: {
      type: "youtube",
      id: "9BOpOF3XCbI"
    }
  },

  {
    id: 3,
    name: "Créature",
    image: "/assets/artistes/2025/Creature_Slide_1.webp",
    image2: "/assets/artistes/2025/Creature_Slide_2.webp",
    description:
      "Creature est né·e de l'union explosive entre la lave d'un volcan sulfureux et les eaux enchantées d'une cascade magique. \nAlchimiste en lien profond avec les éléments, iel s'exprime par la performance, le show, et la présence. \nDe la tente berbère ensorcelée aux clubs en transe, du théâtre au podium, en passant par le chant et le drag, Creature traverse les formes et brouille les frontières. À la Félicita, iel proposera des expériences immersives, intenses et sensorielles. \nAvec amour et douceur, avec feu et splendeur,\nCreature luv u",
    genre: "Performance, show",
    time: "",
    socialLinks: {
      instagram: "https://www.instagram.com/creature.michelle.tv?igsh=dXlweGVpbnJkN2t3",
      LinkTree: "https://linktr.ee/michelle.lesgarcons?utm_source=linktree_profile_share&ltsid=a1fab370-4a4a-43b9-b52f-ae649298fc21&fbclid=PAZXh0bgNhZW0CMTEAAac0qT4vmu01KucR3CuZ9Yq159EUj03Vwzepi5a2Q5JRF3jM9qx7ZNl8efGYWg_aem_QsddBeffsb2hjTi-c8bHZg",
    },
    video: {
      type: "youtube",
      id: "DUi0xiow7sI",
    },
  },

  {
    id: 7,
    name: "",
    image: "/assets/artistes/2025/Amartia_Mou_Slide_1.webp",
    image2: "/assets/artistes/2025/Amartia_Mou_Slide_2.webp",
    description:
      "Au croisement de la nostalgie et de la modernité,\nAmartia Mou réinvente le Laïko grec en chansons\nsincères et vibrantes.\n\nChantant l'amour, l'exil et la joie de vivre, ils vous\nferont voyager... et peut-être danser.",
    genre: "Laïko Grec",
    time: "",
    socialLinks: {
      youtube: "https://www.youtube.com/@Amartia_Mou",
    },
    video: {
      type: "youtube",
      id: "3tpOQ741gWM",
    },
  },
  {
    id: 8,
    name: "Guiby BZB Eerlow",
    image: "/assets/artistes/2025/Guiby_Bzb_Eerlow_Slide_1.webp",
    image2: "/assets/artistes/2025/Guiby_Bzb_Eerlow_Slide_2.webp",
    description: "Techno brute et vibrations électroniques \n Résidents du crew Sincity, Eerlow et Guiby fusionnent \n leurs univers pour un B2B intense, entre hardgroove, acid, \ntextures industrielles et élévation rythmique. \n L'un façonne une techno brute et immersive, \n l'autre insuffle une vibration introspective et singulière. \n Ensemble, ils créent un set puissant et libérateur, taillé \n pour le lâcher-prise et la communion sonore.",
    genre: "TECHNO BRUTE, IMMERSIVE ET VIVANTE",
    time: "",
    socialLinks: {
      instagram1: "https://instagram.com/robichonguillaume",
      instagram2: "https://instagram.com/remiierlo",
    },
    // Structure corrigée pour les vidéos locales multiples
    videos: [
      {
        type: "youtube",
        id: "5jv4OFIjvX0?",
      },
      {
        type: "youtube",
        id: "YRSok757jok"
      }
    ]
  },
  {
    id: 1,
    name: "Nerlov",
    image: "/assets/artistes/2025/Nerlov_Slide_1.webp",
    image2: "/assets/artistes/2025/Nerlov_Slide_2.png",
    description:
      "Nerlov est un artiste qui fusionne des éléments de musique traditionnelle avec des sons modernes, créant une expérience auditive unique.",
    genre: "Pop Electro, Chanson",
    time: "",
    socialLinks: {
      instagram: "https://instagram.com/nerlov.nerlov",
      LinkTree: "https://linktr.ee/nerlov",
    },
    video: {
      type: "youtube",
      id: "uEKRuet1fJw",
    },
  },
  {
    id: 6,
    name: "Marianne Perrudin",
    image: "/assets/artistes/2025/Marianne_Slide_1.webp",
    image2: "/assets/artistes/2025/Marianne_Slide_2.png",
    description:
      "Marianne est une artiste qui explore les thèmes de l'identité et de la culture à travers sa musique, mêlant des influences folk et électroniques.",
    genre: "Folk Délicate",
    time: "",
    socialLinks: {
      instagram: "https://www.instagram.com/marianneperrudin/",
      LinkTree: "https://linktr.ee/marianneperrudin?fbclid=PAZXh0bgNhZW0CMTEAAaeUg5nJqkSbSCrGnoH1wL7rqByW8VBvbfmsyJ95JtqmYxo9gCBDpkje0we9wg_aem_IUc3kQ-tKyMNsqGqwsE8og",
    },
    video: {
      type: "youtube",
      id: "w12YGDnFV7k",
    },
  },


  {
    id: 5,
    name: "Big Alice",
    image: "/assets/artistes/2025/Big_Alice_Slide_1.webp",
    image2: "/assets/artistes/2025/Big_Alice_Slide_2.png",
    description:
      "Big Alice est un groupe qui mélange le rock et la musique traditionnelle, créant un son énergique et captivant.",
    genre: "House Progressive & Hard",
    time: "",
    socialLinks: {
      instagram: "https://www.instagram.com/big.alice?igsh=aW8xamdoY3YxNGp4",
      soundcloud: "https://m.soundcloud.com/big-alice?ref=clipboard&p=i&c=1&si=351C1AF213DE444BB36AAD804F99C718&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
    },
  },
  {
    id: 4,
    name: "Monika",
    image: "/assets/artistes/2025/Monika_Slide_1.webp",
    image2: "/assets/artistes/2025/Monika_Slide_2.png",
    description:
      "Punk Anglais 90's & Techno",
    genre: "Jazz Pop",
    time: "",
    socialLinks: {
      instagram: "https://www.instagram.com/monika.wav/",
      LinkTree: "https://linktr.ee/monika.wav?fbclid=PAZXh0bgNhZW0CMTEAAad5YXKv6UwMim3N3x6xuDbxAejSQ01DJ5FV5IEF4HDD35PcXevGDu1-K4MnBw_aem_504iEE0otn4lDgtyJRuhYg",
    },
    video: {
      type: "youtube",
      id: "-Q9sq3qvyH0",
    },
  }
];

// Fonctions utiles pour manipuler les données
export const getArtistById = (id) =>
  artistes2025.find((artist) => artist.id === id);

export const getArtistsByGenre = (genre) =>
  artistes2025.filter((artist) => artist.genre === genre);

export const getArtistsByTimeSlot = (timeStart, timeEnd) => {
  return artistes2025.filter((artist) => {
    // Conversion simple des heures pour comparaison
    const artistHour = parseInt(artist.time.split("h")[0]);
    const startHour = parseInt(timeStart.split("h")[0]);
    const endHour = parseInt(timeEnd.split("h")[0]);

    return artistHour >= startHour && artistHour <= endHour;
  });
};

// Export par défaut de toutes les données
export default artistes2025;